import React from 'react';

/**
 * Sidebar toggle button — Stitch design: round floating chevron button
 * pinned to the sidebar's outer edge, vertically centered.
 */
function SidebarToggle({ isExpanded, onToggle, position = 'left' }) {
    const isLeft = position === 'left';

    const getLeftValue = () => {
        if (isLeft) {
            return isExpanded ? 'calc(260px - 16px)' : 'calc(80px - 16px)';
        }
        return 'auto';
    };

    const getRightValue = () => {
        if (!isLeft) {
            return isExpanded ? 'calc(280px - 16px)' : 'calc(80px - 16px)';
        }
        return 'auto';
    };

    const getChevron = () => {
        if (isLeft) {
            return isExpanded
                ? <polyline points="15 18 9 12 15 6"></polyline>
                : <polyline points="9 18 15 12 9 6"></polyline>;
        } else {
            return isExpanded
                ? <polyline points="9 18 15 12 9 6"></polyline>
                : <polyline points="15 18 9 12 15 6"></polyline>;
        }
    };

    return (
        <button
            onClick={onToggle}
            title={isExpanded ? 'Collapse sidebar' : 'Expand sidebar'}
            style={{
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                left: getLeftValue(),
                right: getRightValue(),
                width: '32px',
                height: '32px',
                background: 'rgba(13, 14, 15, 0.85)',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                border: '1px solid rgba(0, 218, 243, 0.35)',
                borderRadius: '50%',
                cursor: 'pointer',
                color: 'var(--accent)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1001,
                boxShadow: '0 4px 16px rgba(0, 0, 0, 0.5)',
                transition: 'left 0.3s cubic-bezier(0.4, 0, 0.2, 1), right 0.3s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.2s ease',
                padding: 0,
                margin: 0,
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(0, 218, 243, 0.2)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(13, 14, 15, 0.85)';
            }}
        >
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                {getChevron()}
            </svg>
        </button>
    );
}

export default SidebarToggle;
